import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";


declare var ko: any;

export class speedTestAdsAuditDomainConfig_template extends vnTemplate {

    protected statusFilter : multipleSelector_template;
    protected domainFilter : multipleSelector_template;

    protected pagination: pagination_template;
    protected headers: simpleListHeader_template;

    protected getTemplateHtml(): string {

        return  `

                
                <div class="sub-header">
                    <div class="w-justify">
                        <div class="w-left">
                            ${ this.statusFilter.getHtmlBuild() }
                            ${ this.domainFilter.getHtmlBuild() }
                        </div>
                    </div>
                </div>   
                
                 <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                       <div id="selected-statuses"></div>
                       <div id="selected-domains"></div>
                    </div>   
                </div>
                
                <div class="list-header w-justify margin-top">
                
                    <div class="w-left">
                        <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Back</button>
                        <button data-bind="click: onClickAdd" class="btn secondary icon i-add" type="button">Add Domain Configuration</button>
                    </div>
                    <div class="w-right">
                        ${ this.pagination.getHtmlBuild() }
                    </div>
                </div>
                
                <div class="w-list-results transaction-int-list"  id="list-results">
                    <table class="list-results">
                        
                        <thead>
                            ` + this.headers.getHtmlBuild()  + `
                        </thead>                    
                        <tbody data-bind="foreach: configs">        
                            <tr>
                                <td class="align-left">
                                    <span class="w-btn">
                                            <button class="btn icon border only-icon icon i-edit" type="button" title="Edit" data-bind="click: $parent.onClickEdit, clickBubble: false"></button>
                                    </span>
                                </td>
                                <td class=""><span data-bind="text: dateCreated"></span></td>
                                <td class=""><span data-bind="text: domainName"></span></td>
                                <td class=""><span data-bind="text: groupName"></span></td>
                                <td class=""><span data-bind="text: urlCount"></span></td>
                                <td class=""><span data-bind="text: contentTypeNames"></span></td>
                                <td class=""><span data-bind="text: typeName"></span></td>
                                <td class="">
                                    <label class="w-toggle">
                                        <input type="checkbox" name="checkbox" data-bind="checked: statusName == 'Active', click: $parent.onClickActivation">
                                        <span class="slider round"></span>
                                    </label>
                                </td>
                                <td class=""><span data-bind="text: statusName"></span></td>
                                <td class="align-right"><button class="btn icon border only-icon highlight i-delete" type="button" data-bind="click: $parent.onClickDelete, clickBubble: false"></button></td>
                                <td class="align-right"><button class="btn icon border only-icon highlight i-log" type="button" data-bind="click: $parent.onClickLog, clickBubble: false"></button></td>
                            </tr>                 
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>
                
                <div id="delete-dialog" class="w-lightbox dark-theme">
                    <div class="lightbox-content ">
                        
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Delete domain configuration</h3>
                                <button data-bind="event: { click: onClickDeleteDialogHide }" type="button" class="close-btn icon i-close"></button>
                            </div>
                   
                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">This action is irreversible</p>
                                    <p class="form-text">Are you sure you want to permanently delete this domain configuration?</p>   
                                </div>
                            </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickDeleteDialogHide }" class="btn" type="button">Cancel</button>
                            <button data-bind="event: { click: onClickDeleteConfirm }" class="btn highlight half" type="button">Delete</button>
                        </div>
                    </div>
                    
                </div>
            `;
    }

    protected initPartial(): void {

        this.statusFilter = new multipleSelector_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel("Status");
        this.statusFilter.setFilterContainerClass('margin-neg');
        this.statusFilter.setTagContainerId('selected-statuses');
        this.statusFilter.setTagContainerCaption('Selected statuses:');

        this.domainFilter = new multipleSelector_template("domainFilter", this.getTemplateViewModel(), this.caller);
        this.domainFilter.setLabel("Domain");
        this.domainFilter.setFilterContainerClass('margin-neg');
        this.domainFilter.setTagContainerId('selected-domains');
        this.domainFilter.setTagContainerCaption('Selected domains:');

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        let headers = [
            {headerName: "Edit", fieldName: null, subHeaders: []},
            {headerName: "Date Created", fieldName: "dateCreated", subHeaders: []},
            {headerName: "Domain", fieldName: "domainName", subHeaders: []},
            {headerName: "Industry", fieldName: "groupName", subHeaders: []},
            {headerName: "URLs", fieldName: "urlCount", subHeaders: []},
            {headerName: "Content Type", fieldName: "contentTypeNames", subHeaders: []},
            {headerName: "Type", fieldName: "typeName", subHeaders: []},
            {headerName: "Start/Stop", fieldName: null, subHeaders: []},
            {headerName: "Status", fieldName: "status", subHeaders: []},
            {headerName: "Delete", fieldName: null, subHeaders: []},
            {headerName: "Log", fieldName: null, subHeaders: []},
        ];
        this.headers = new simpleListHeader_template("listHeader", this.getTemplateViewModel(), this.caller, headers);
        this.headers.getTemplateViewModel().orderBy("dateCreated");
        this.headers.getTemplateViewModel().orderByDirection("DESC");
        this.headers.getTemplateViewModel().orderByAndDirection("dateCreated_DESC");
    }

    protected getTemplateName(): string {

        return "speedTestAdsAuditDomainConfig_template";
    }

    public resetPageNumber(): void {

        this.pagination.getTemplateViewModel().pageNumber(1);
    }

    protected getMainElementType(): string {

        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the view model data/ functions
        let me = this;
        return {
            configs: ko.observableArray([]),
            configToDelete: ko.observableArray([]),
            onClickEdit: function (data, event) {

                me.onClickEdit(data.idDomain);
            },
            onClickAdd: function (data, event) {

                me.onClickAdd();
            },
            onClickDelete: function(data,event){

                me.onClickDelete(data);
            },
            onClickLog: function(data,event){

                me.onClickLog(data);
            },
            onClickActivation: function(data,event){

                return me.onClickActivation(data);
            },
            onClickDeleteDialogHide: function(data, event){

                me.onClickDeleteDialogHide();
            },
            onClickDeleteConfirm: function(data, event){

                me.onClickDeleteConfirm();
            },
            onClickCancel: function(data, event){

                me.onClickCancel();
            }
        };
    }

    public getViewModelForRequest() {

        return {
            configToDelete: this.getTemplateViewModel().configToDelete,
            pagination: this.getTemplateViewModel().pagination,
            headers: this.headers.getViewModelForRequest(),
            filter: {
                status: this.getTemplateViewModel().statusFilter.selectedItems,
                domain: this.getTemplateViewModel().domainFilter.selectedItems,
            }
        }
    }


    public onClickDeleteDialogHide() {

        this.toggleDeleteDialogVisibility();
    }

    public onClickDelete(data) {

        this.getTemplateViewModel().configToDelete(data);
        this.toggleDeleteDialogVisibility();
    }

    public onClickLog(data) {

        this.caller.log(data.idDomain);
    }

    protected onClickDeleteConfirm(): void{

        this.toggleDeleteDialogVisibility();
        this.caller.deleteConfig();
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }

    public onClickEdit(idDomain): void {

        this.caller.editDomainConfig(idDomain);
    }

    public onClickAdd(): void {

        this.caller.addDomainConfig();
    }

    public setDomainConfigs(configs: Array<{ id: number, name: string, dateCreated: string}>): void {

        this.getTemplateViewModel().configs(configs);
    }

    public setPaginationTotalCount(totalCount: number):  void {

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public setStatusFilterItems(items){

        this.statusFilter.setItems(items);
    }

    public setDomainFilterItems(groupedDomains: Array<any>): void {

        this.domainFilter.setMultiSectionItems(groupedDomains);
        this.domainFilter.setLabel("Domains");
    }

    public onClickActivation(data) {

        if (data.statusName == "Active") {

            this.caller.deactivateConfig(data.idDomain);
        }else {

            this.caller.activateConfig(data.idDomain);
        }

        return true;
    }

    public onClickCancel(): void{

        this.caller.cancel();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/speedTestAdsAuditDomainConfig_template.ts